import { render, staticRenderFns } from "./AccountsReceivablesDetails.vue?vue&type=template&id=073cc197&scoped=true&"
import script from "./AccountsReceivablesDetails.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivablesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073cc197",
  null
  
)

export default component.exports